import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFollowerChange = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 62.83245 62.84409",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "follwerChange" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42.50624,22.927v4.098l-.82137,4.94614a19.232,19.232,0,0,1-3.54447,8.77631V48.372s-2.12489,2.83913-6.97283,2.88381c-4.84794-.04468-6.97283-2.89274-6.97283-2.89274V40.74743a19.13561,19.13561,0,0,1-3.5266-8.79419L19.8289,27.025V22.927a11.33867,11.33867,0,1,1,22.67734,0Z",
			style: {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "42.679 28.281 47.825 41.852 53.241 28.246 61.582 28.246",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("polyline", {
			points: "1.25 27.923 9.117 27.923 14.792 14.64 19.964 28.281",
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 42.50624,
			y1: 27.02498,
			x2: 41.68485,
			y2: 31.97114,
			style: {
				fill: "none",
				stroke: "#4c30fa",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2.5px"
			}
		})
	] })]
});
export default SvgFollowerChange;
